import React, { useState, useReducer, useEffect } from "react"
import { Checkbox } from "antd"

const ClosedSupport = ({ rowData, mainProps }) => {
  return (
    <Checkbox
      checked={rowData.closed}
      onChange={async () => {
        const { onClosedSupport } = mainProps
        if (window.confirm("آیا مطمئن هستید")) {
          await onClosedSupport({ id: rowData.id, closed: !rowData.closed })
        }
      }}
    >بستن</Checkbox>
  )
}

export default ClosedSupport
